export default class BaseState<U>
{
    Model:U;
    
    constructor(Model:U)
    {
        this.Model=Model;
    }
}